import React, { Component, useEffect, useState } from 'react'
import { saveTalentQuestion, loadLanguages, loadQuestion } from '../utils/Network';
import { useHistory } from 'react-router';


import { Link } from 'react-router-dom';
import { getDefaultName } from '../utils';

export default function TalentQuestionContent({ talent_id, question_id, callback, isModal = false, onClose = null, onSaved = null }) {


    const history = useHistory();

    const [Names, setNames] = useState([]);
    const [talentQuestion, settalentQuestion] = useState([]);
    const [languages, setLanguages] = useState(null);


    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        loadLanguages().then(languages => {

            //languages=languages.filter(x=> x.language !==16)
            setLanguages(languages);

        });



        if (question_id) {
            
            loadQuestion(question_id).then(talentQuestion => {
                setNames(talentQuestion.names)
                settalentQuestion(talentQuestion)

            })
        }
    }, [])

    const handleOnChange = (e) => {
        var language_id = e.target.getAttribute("language_id")

        if (language_id) {
            var name = "";
            if (Names) {
                name = Names.find(x => x.language === parseInt(language_id));
            }
            if (name) {
                var temp_talentNames = [...Names];
                temp_talentNames.find(x => x.language === parseInt(language_id)).name = e.target.value;
                setNames(temp_talentNames)
            }
            else {

                var new_name = { name: e.target.value, language: parseInt(language_id) }
                var temp_talentNamesa = [];
                if (Names)
                    temp_talentNamesa = [...Names, new_name];
                else temp_talentNamesa = [new_name]
                setNames(temp_talentNamesa)
            }
        }
        else {
            switch (e.target.name) {
                case 'weight':
                    var temp = talentQuestion;
                    temp.weight = e.target.value;
                    settalentQuestion(temp)
                    break;
                default:
                    break;
            }
        }

    }

    const saveChanges = () => {

        setError(false);
        setLoading(true);
        //alert(talentNames[0].name)
        if (!Names || Names[0].name.length < 3) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }

        saveTalentQuestion(talent_id, { id: question_id, weight: talentQuestion.weight, names: Names })
            .then(function (data) {
                setLoading(false);
                callback()
                if (onSaved) onSaved(data);
            });;
    }

    return (
        <>
            <div className="cms-dark-box">
                
                <div className="box-body">

                    <div className="form-group">
                        
                        {languages && languages.map((language, i) =>
                        (
                            <div key={language.id + "language"} className="form-group row">
                                <label className="col-sm-2 col-form-label kfont">{language.name}</label>
                                <div className="col-sm-10">
                                    <input key={i} type="text" name="name" className="form-control max-200" language_id={language.id} value={Names && Names.find(x => x.language === language.id) ? Names.find(x => x.language === language.id).name : ""} onChange={handleOnChange} placeholder="Name" />
                                </div>
                            </div>
                        ))}
                        <hr className="hr" />
                    </div>

                    <div className="form-group">
                        <div className="form-group row">
                            <label className="col-sm-2 col-form-label">Weight</label>
                            <div className="col-sm-10">
                                <input type="number" name="weight" className="form-control max-200" defaultValue={talentQuestion && talentQuestion.weight} onChange={handleOnChange} placeholder="Weight" />
                            </div>
                        </div>
                    </div>
                   

                </div>

                <div className="box-footer">
                    <button type="button" onClick={saveChanges} disabled={loading} className="btn btn-primary pull-right">Save Changes</button>
                    {isModal && (
                        <button type="button" onClick={onClose} className="btn btn-dark">Cancel</button>
                    )}
                    {!isModal && question_id && (<>
                        <a href={`talents/${talent_id}/questions/`} className="btn btn-dark">Cancel</a>
                    </>)}
                </div>


            </div>
            
            {error && (
                <>
                    <div className="alert alert-danger">
                        {error}
                    </div>
                </>
            )}

            {loading && (
                <>
                    <div className="alert alert-info">
                        please wait...
                    </div>
                </>
            )}
        </>


    )

}
